import apiClient from '../client/api-client'
const lodashClonedeep = require('lodash.clonedeep')
import { baseURL } from 'config'
import axios from 'axios'

const objectStore = 'objectstore'
const diseaseCards = 'disease-cards'
const v3 = 'v3'

import {
  findCancerEntityById,
  getDetailedEntities,
  createTimelineView
} from '../utils/cancer-helpers.js'

import { Constants } from '@ciitizen/component-library'

export default {
  async fetchCancerData({ token, ignoreStatus, grantor, forCtzId }) {
    try {
      const authToken = localStorage.getItem('default_auth_token')
      let payload = ''
      if (authToken) {
        payload = await apiClient.get(`/${objectStore}/${diseaseCards}/${v3}`, {
          token,
          params: {
            ignoreStatus,
            grantor,
            'for-ctz-id': forCtzId
          }
        })
      } else {
        const headers = {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
        payload = await axios.get(`${baseURL}/${objectStore}/${diseaseCards}/${v3}`, {
          headers: headers,
          params: {
            ignoreStatus,
            grantor
          }
        })
      }
      let data = payload.data
      // remove any "empty" cancer cards: every cc must have a graph
      const allCCData = data.filter(d => d.graph)
      let filtered = allCCData,
        fullTimelineFiltered = []
      filtered.map(entity => {
        entity.graph = getDetailedEntities(entity.graph, entity)
        /* graph entities of both liquid and solid cancer cards go in the full timeline
          but we leave out liquid and solid orphans UNLESS there are no primary diagnosis */
        let containsPrimary = entity.graph.some(m => m.entityType === 'primaryDiagnosis')
        const filteredGraph = []
        if (containsPrimary) {
          entity.graph.forEach(item => {
            if (
              item.entityType === 'therapeuticIntervention' &&
              item.code.terminology !== 'SNOMED_US'
            ) {
              filteredGraph.push(item)
            } else if (!Constants.diseaseSummary.ORPHANS.includes(item.entityType)) {
              filteredGraph.push(item)
            }
          })
        } else {
          entity.graph.forEach(item => {
            if (item.key) filteredGraph.push(item) // TEMPORARY TILL DATA ISSUE RESOLVED
          })
        }
        fullTimelineFiltered.push(...filteredGraph)
        if (Object.keys(entity).includes('primaryDiagnosis')) {
          let diagnosisOrphans = [] // diagnostic orphans are: generic + patient level entities
          // we first go through the graph and pick out diagnostic orphans by disease type
          entity.graph.forEach(item => {
            let orphansList =
              entity.meta.diseaseType === 'liquid'
                ? Constants.diseaseSummary.LIQUID_DIAGNOSIS_ORPHANS
                : Constants.diseaseSummary.SOLID_DIAGNOSIS_ORPHANS
            if (orphansList.includes(item.entityType)) {
              let itemCopy = { ...item }
              diagnosisOrphans.push(itemCopy)
            }
          })
          for (let graphItem of entity.graph) {
            if (graphItem.entityType === 'primaryDiagnosis') {
              let deets = findCancerEntityById(graphItem.id, entity)
              deets.meta = entity.meta
              graphItem = Object.assign(graphItem, deets)
              if (graphItem.children) {
                // make a copy so the timeline changes dont affect original list
                const orphansCopy = lodashClonedeep(diagnosisOrphans)
                // add the diagnosis orphans to every primary diagnosis
                graphItem.children = graphItem.children.concat(orphansCopy)
                // apply timeline rules to primary diagnosis children
                graphItem.children = createTimelineView(graphItem.children, allCCData)
                // if the primary diagnosis doesnt have kids just add orphans
              } else {
                graphItem.children = []
                // make a copy so the timeline changes dont affect original list
                const orphansCopy = lodashClonedeep(diagnosisOrphans)
                // add the diagnosis orphans to every primary diagnosis
                graphItem.children = graphItem.children.concat(orphansCopy)
                // apply timeline rules to primary diagnosis children
                graphItem.children = createTimelineView(graphItem.children, allCCData)
              }
            }
          }
        }
      })
      if (fullTimelineFiltered.length) {
        filtered.push({
          entityType: 'full_timeline',
          children: createTimelineView(fullTimelineFiltered, allCCData)
        })
      }
      return Promise.resolve(filtered)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
